import * as React from 'react';
import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css';
import MinimalSortableTreeTheme from 'react-sortable-tree-theme-minimal';

import { TreeWrapper, ItemWrapper, ItemIcon, ItemTitle } from './styles';
import { getNodeKey, mapOverTree } from 'TaxonomyMapper/utils';

export const SimpleTree = props => {
	const {
		data: treeData,
		treeConfig = {},
		onChange,
		selectedTreeItem,
		searchQuery,
		onTreeItemClick,
		enableParentSelection,
	} = props;

	const getFormattedTitle = node => {
		const nodeProps = onTreeItemClick
			? {
					role: 'button',
					onClick: () => {
						if (node.children.length === 0 || enableParentSelection) {
							onTreeItemClick(node);
						} else {
							// toggle expanded
							const newTreeData = mapOverTree(treeData, item => {
								if (item.id === node.id) {
									return { ...item, expanded: !item.expanded };
								}
								return item;
							});
							onChange(newTreeData);
						}
					},
			  }
			: {};

		return (
			<ItemWrapper {...nodeProps}>
				{node.children.length === 0 && <ItemIcon />}
				<ItemTitle level={node.level}>{node.name}</ItemTitle>
			</ItemWrapper>
		);
	};

	return (
		<TreeWrapper>
			<SortableTree
				theme={MinimalSortableTreeTheme}
				treeData={treeData || []}
				searchMethod={treeSearchMethod}
				searchQuery={searchQuery}
				searchFocusOffset={0}
				onChange={e => {
					console.log(e);
				}}
				canDrop={() => false}
				canDrag={() => false}
				rowHeight={28}
				scaffoldBlockPxWidth={20}
				getNodeKey={getNodeKey}
				generateNodeProps={({ node }) => {
					let className;

					if (selectedTreeItem && node.id === selectedTreeItem.id) {
						className = 'node-selected';
					}

					return {
						title: getFormattedTitle(node),
						className,
					};
				}}
				{...treeConfig}
			/>
		</TreeWrapper>
	);
};

const treeSearchMethod = ({ node, searchQuery }) =>
	searchQuery &&
	(searchQuery && Array.isArray(searchQuery)
		? searchQuery.includes(node.id)
		: node.id === searchQuery);
